import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function equalPasswords(firstControlName: string, secondControlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const firstControl = control.get(firstControlName);
        const secondControl = control.get(secondControlName);

        if (secondControl?.value != null && secondControl.value !== firstControl?.value) {
            secondControl.setErrors({ notEqual: true });
            return { notEqual: true };
        }

        return null;
    };
}
